/* src/app/modulos/mensagem/mensagem.component.scss */
/*# sourceMappingURL=mensagem.component.css.map */
